import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

function FullImage(props) {
  const { data } = props;
  return (
    <Box>
      <img src={data.image.url} alt={data.image.alt} />
    </Box>
  );
}

FullImage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default FullImage;
